import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import AlertBox from "../../../components/common/AlertBox";
import Loading from "../../../components/common/Loading";
import ResultFragment from "../../../components/home/examPage/ResultFragment";
import HomeLayout from "../../../components/home/common/HomeLayout";
import {
  clearResult,
  getAResult,
  getResultHistoryData,
  getResulthistoryError,
  getResultHistoryStatus,
} from "../../../redux/slice/historySlice";
import { useParams } from "react-router-dom";

const HistoryViewPage = () => {
  const dispatch = useDispatch();

  const id = useParams().id;

  const status = useSelector(getResultHistoryStatus);
  const error = useSelector(getResulthistoryError);
  const data = useSelector(getResultHistoryData);

  useEffect(() => {
    dispatch(getAResult(id));
    return () => {
      dispatch(clearResult());
    };
  }, [dispatch, id]);

  return (
    <div>
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type="failed" message={error} /> : null}
      <HomeLayout>{data && <ResultFragment examData={data} />}</HomeLayout>
    </div>
  );
};

export default HistoryViewPage;
